import React from 'react'

import '../styles/gift.scss'

function Gift() {
  return (
    <div className="account-gift">
      <p className="account-gift__title">А еще подписку можно подарить!</p>
      <p className="account-gift__text">О да. Порадуйте маму, друга, детей, коллегу, жену, мужа или всех своих подданных — купите им подписку на Arzamas или Гусьгусь: на год, на два, на три или даже навсегда (!).</p>
      <a className="account-gift__button account-button" href="/gift">Подарить</a>
    </div>
  )
}

export default React.memo(Gift)
